export var DiscountStatus;
(function (DiscountStatus) {
    /** Status is unknown or not specified. */
    DiscountStatus["UNKNOWN"] = "UNKNOWN";
    /** Discount has been applied to the checkout. */
    DiscountStatus["APPLIED"] = "APPLIED";
    /** Discount application is in progress. */
    DiscountStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /** Discount has been successfully completed. */
    DiscountStatus["COMPLETED"] = "COMPLETED";
    /** Discount has been refunded. */
    DiscountStatus["REFUNDED"] = "REFUNDED";
    /** Attempt to refund the discount failed. */
    DiscountStatus["FAILED_TO_REFUND"] = "FAILED_TO_REFUND";
    /** Discount was refunded due to a timeout. */
    DiscountStatus["REFUNDED_DUE_TO_TIMEOUT"] = "REFUNDED_DUE_TO_TIMEOUT";
    /** Discount was refunded due to manual removal. */
    DiscountStatus["REFUNDED_DUE_TO_MANUAL_DISCOUNT_REMOVAL"] = "REFUNDED_DUE_TO_MANUAL_DISCOUNT_REMOVAL";
    /** Discount is scheduled for refund. */
    DiscountStatus["SCHEDULED_FOR_REFUND"] = "SCHEDULED_FOR_REFUND";
    /** Discount was not used. */
    DiscountStatus["UNUSED"] = "UNUSED";
})(DiscountStatus || (DiscountStatus = {}));
export var DiscountType;
(function (DiscountType) {
    /** Discount type is unknown or not specified. */
    DiscountType["UNKNOWN"] = "UNKNOWN";
    /** A discount from a flexible reward. */
    DiscountType["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    /** A discount from a redeemed loyalty program coupon. */
    DiscountType["LOYALTY_COUPON"] = "LOYALTY_COUPON";
    /** A discount from a coupon reward that has not yet been redeemed. */
    DiscountType["COUPON_REWARD"] = "COUPON_REWARD";
    /** A discount from a referral reward. */
    DiscountType["REFERRAL_REWARD"] = "REFERRAL_REWARD";
})(DiscountType || (DiscountType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map